import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mapa-modulo',
  templateUrl: './mapa-modulo.component.html',
  styleUrls: ['./mapa-modulo.component.scss']
})
export class MapaModuloComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
